export default {
  generateRandomPasscode: (len = 4) => {
    return String(Math.floor(Math.random() * Math.pow(10, len)));
  }
}


// WEBPACK FOOTER //
// ./src/tools/PasscodeHelper.js